var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /** @format */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18NLink } from "../../I18N";
import PagesContext from "./Context";

export default class EntityLink extends Component {
  render() {
    const { children } = this.props;
    return /*#__PURE__*/(
      _jsx(PagesContext.Consumer, {}, void 0,
      (entity) => {
        const sharedId = entity.toJS ? entity.get('sharedId') : entity.sharedId;
        const url = `/entity/${sharedId}`;
        return /*#__PURE__*/_jsx(I18NLink, { to: url }, void 0, children);
      }
      ));

  }
}

EntityLink.defaultProps = {
  children: ''
};